<template>
  <v-card color_="blue-grey darken-2" class_="white--text" class="elevation-2">
    <v-card-title primary-title class_="blue-grey darken-2">
      <div>
        <div class="subtitle-1 font-weight-medium mb-2">
          Produtos Vendidos por Lote
        </div>
        <div class="body-2">
          Relação dos produtos vendidos por lote no período.
        </div>
      </div>
    </v-card-title>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn small text color="primary" @click="$refs.dialogo.abrir()"
        >Opções</v-btn
      >
    </v-card-actions>

    <v-divider v-show="aberto"></v-divider>

    <z-dialogo
      ref="dialogo"
      titulo="PRODUTOS VENDIDOS POR LOTE"
      largura="500px"
    >
      <template v-slot:texto>
        <v-row dense>
          <v-col cols="12" sm="6">
            <z-date-picker-menu
              label="Data Incial"
              v-model="filtro.data_inicial"
            ></z-date-picker-menu>
          </v-col>
          <v-col cols="12" sm="6">
            <z-date-picker-menu
              label="Data Final"
              v-model="filtro.data_final"
            ></z-date-picker-menu>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete
              v-model="filtro.lote_id"
              :items="lotes"
              clearable
              label="Lote"
              placeholder=" "
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-select
              :items="ordenacao"
              label="Ordenar por"
              placeholder=" "
              v-model="filtro.ordem"
            ></v-select>
          </v-col>
        </v-row>
      </template>

      <template v-slot:actions_right>
        <v-spacer></v-spacer>
        <v-btn text @click="$refs.dialogo.fechar()">Cancelar</v-btn>
        <v-btn text color="primary" @click="imprimir">Imprimir</v-btn>
      </template>
    </z-dialogo>
  </v-card>
</template>

<script>
import qs from "qs";
import config from "../../app/config";
export default {
  name: "produtos-vendidos-por-lote",
  data() {
    return {
      aberto: false,
      filtro: {
        data_inicial: this.$moment().format("YYYY-MM-DD"),
        data_final: this.$moment().format("YYYY-MM-DD"),
        ordem: "quantidade_total",
        lote_id: "",
      },
      ordenacao: [
        { text: "Quantidade", value: "quantidade_total" },
        { text: "Sub Total", value: "subtotal" },
        { text: "Descrição", value: "descricao" },
        { text: "Referência", value: "referencia" },
      ],
    };
  },

  computed: {
    lotes() {
      return this.$store.getters["listas/lotes"];
    },
  },

  mounted() {
    this.$store.dispatch("listas/lotes");
  },

  methods: {
    imprimir() {
      if (config.IS_PRODUCTION) {
        this.abrirJanela(
          window.location.origin +
            "/relatorios/produtosvendidosporlote?" +
            qs.stringify(this.filtro)
        );
      } else {
        this.abrirJanela(
          "http://localhost:8001/relatorios/produtosvendidosporlote?" +
            qs.stringify(this.filtro)
        );
      }
    },
  },
};
</script>

<style scoped></style>
